import { isAxiosError } from 'axios'

import { ModelErrorResponse } from '../apis/fvillage'

// Error contract of the invoice URL (`?invoice_key=`) on the backend (SB-3055).
const INVOICE_ACCESS_KEY_PARAM = 'invoice_access_key'
const INVOICE_ACCESS_KEY_INVALID_REASON = 'invalid'
const PLAN_PARAM = 'plan'
const INVOICE_ACCESS_KEY_NO_LONGER_VALID_REASON =
  'Invoice access key is no longer valid'

const hasInvalidParam = (error: unknown, name: string, reason: string) => {
  if (!isAxiosError<ModelErrorResponse>(error)) {
    return false
  }
  return (error.response?.data?.invalidParams ?? []).some(
    (param) => param.name === name && param.reason === reason
  )
}

// Transaction create rejected the key: it does not open this plan.
export const isInvalidInvoiceAccessKeyError = (error: unknown) =>
  isAxiosError(error) &&
  error.response?.status === 400 &&
  hasInvalidParam(
    error,
    INVOICE_ACCESS_KEY_PARAM,
    INVOICE_ACCESS_KEY_INVALID_REASON
  )

// Reservation create refused the booking: the key was reissued or switched off
// after the input step, so the guest who entered no card cannot be charged.
export const isInvoiceAccessKeyNoLongerValidError = (error: unknown) =>
  hasInvalidParam(error, PLAN_PARAM, INVOICE_ACCESS_KEY_NO_LONGER_VALID_REASON)
